// extracted by mini-css-extract-plugin
export var dropdownMenu = "navigation-module--dropdown-menu--06a39";
export var headerDivider = "navigation-module--header-divider--8b931";
export var logo = "navigation-module--logo--b9fdd";
export var navItem = "navigation-module--nav-item--7bc50";
export var poza = "navigation-module--poza--1a518";
export var subMenuDropDown = "navigation-module--subMenuDropDown--74926";
export var text = "navigation-module--text--ce21d";